import React from 'react';

function Syllabus(){
    return(
        <div className = "books">
            <h1 id="title">Syllabus</h1>
    <nav id="tree-list">
        <ul className="container">
            <li>
                <h3 data-aos="flip-left">Computer Science and Engineering</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Syllabus <a href="https://drive.google.com/open?id=1p-9UZOiov2al8nf8O3KcMniYqEWBRyvn"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Information Techgnology</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Syllabus <a href="https://drive.google.com/open?id=129AygOljhsxaVwCzoaDWfPVSydW0-2Cq"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Electronics &amp; Communication Engineering</h3>
                <ul className="tree-down"  data-aos="fade-up">
                   <li>Syllabus <a href="https://drive.google.com/open?id=16WJAU6bleTfWOdqcZ7ztOfv00XPUHSTr"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            </ul>
    </nav>
</div>
    )
}

export default Syllabus;